import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100dvh;
  background-color: #ff6900;
  position: relative;
  background-repeat: no-repeat;
  background-position-y: 680px;
  background-position-x: right;
  overflow-x: hidden;
`;
